import { useEffect, useState } from "react";
import axios from "../../../../requests/axios";
import routes from "../../../../requests/routes";
import Loader from "../../../../layouts/loader/Loader";
import UserCard from "../userCard/UserCard";
import classes from "./UserPrograms.module.scss";

export const UserPrograms = ({ record }) => {
  const wishlist = record.programs;
  const [adminPrograms, setAdminPrograms] = useState([]);
  const [loader, setLoader] = useState(true);

  async function getPrograms() {
    try {
      const response = await axios.get(routes.getPrograms);
      setAdminPrograms(response.data.programs);
      setLoader(false);
    } catch (err) {}
  }
  useEffect(() => {
    getPrograms();
  }, []);

  const wishIdSet = new Set(wishlist.map(String));
  const filteredPrograms = adminPrograms.filter((p) =>
    wishIdSet.has(String(p._id ?? p.id))
  );

  return (
    <>
      <div className={classes.cards}>
        {loader ? (
          <Loader color={"#F46444"} />
        ) : filteredPrograms.length > 0 ? (
          filteredPrograms.map((wl, index) => (
            <UserCard key={index} user={wl} />
          ))
        ) : (
          <>No Data</>
        )}
      </div>
    </>
  );
};
